export const FILTER_KEYS = ['status', 'categories', 'providerIn'] as const;

export type FilterKeys = (typeof FILTER_KEYS)[number];

export const FILTER_RANGE_KEYS = ['price', 'rating'];
